module.exports = __webpack_public_path__ + "static/multi-step-commercial-642f1e60403ac5d1281ec2475db90a59.svg";